module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("关于我们")])])], 1), _vm._v(" "), _c('el-form', {
    ref: "aboutForm",
    attrs: {
      "model": _vm.aboutForm,
      "rules": _vm.bannerFormFules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "关于我们LOGO图",
      "label-width": "150px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "https://upload.qiniup.com/",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "on-error": _vm.handleError,
      "before-upload": _vm.beforeAvatarUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.imgUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imgUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "当前版本号",
      "label-width": "150px",
      "prop": "description"
    }
  }, [(_vm.aboutForm.value) ? _c('el-input', {
    model: {
      value: (_vm.aboutForm.value.version),
      callback: function($$v) {
        _vm.$set(_vm.aboutForm.value, "version", $$v)
      },
      expression: "aboutForm.value.version"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cc21d18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/other/About.vue
// module id = 740
// module chunks = 1